export default function CtaSection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[320px] lg:min-h-[560px]">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20curated%20fashion%20essentials%20with%20textured%20sneakers%20folded%20cashmere%20sweater%20leather%20accessories%20and%20designer%20sunglasses%20arranged%20on%20warm%20cream%20linen%20fabric%20soft%20natural%20daylight%20editorial%20lifestyle%20photography%20harmonious%20composition&width=960&height=1200&seq=cta-left-home-v2&orientation=portrait"
          alt="OOPBuy Spreadsheet product sourcing tools"
          title="OOPBuy Spreadsheet - Product Sourcing System"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/15"></div>
        <div className="relative z-10 p-8 md:p-14 flex flex-col justify-between h-full">
          <span className="text-xs font-medium text-white/80 uppercase tracking-widest">
            Limited Access
          </span>
          <div className="pb-8">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-none drop-shadow-md">
              <span className="block font-light">Get Your</span>
              <span className="block font-bold mt-1">OOPBuy</span>
              <span className="block font-light italic mt-1">Spreadsheet</span>
            </h2>
          </div>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-14">
        <div className="max-w-md text-center flex flex-col items-center gap-5">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
            Track Smarter
            <br />
            Sell Faster
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            Ready to transform your e-commerce workflow? The complete OOPBuy spreadsheet system gives you everything you need to manage products, calculate profits, and scale your reselling business with confidence. Thousands of sellers already trust this proven tracking system.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-foreground-950 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-accent-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            OOPBuy Spreadsheet
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}